import { ajax } from '@/api/ajax';
import type { XDragonApiResponsePromise } from '@/api/ajax';

export interface PartReq {
  /**
   * 备件编码
   */
  partNo?: string;
}

export type PartPhotoUsingPostApiResponse = PartListPhotoResp[];

export interface PartListPhotoResp {
  /**
   * 图片id
   */
  fileId?: string;
  /**
   * id
   */
  id?: number;
  /**
   * 备件编码
   */
  partNo?: string;
  /**
   * 照片来源 1-手工 2-哈雷
   */
  photoSource?: number;
  /**
   * 图片分类 1-左 2-右 3-钢印 4-前 5-后 6-其他
   */
  photoType?: number;
}

/**
 * @operationId partPhotoUsingPOST
 * @tags EPC目录查询
 * @logan http://logan-gateway.test.logan.xiaopeng.local/xp-ass-epc-cn-boot/doc.html#/EPC-%E7%9B%AE%E5%BD%95%E6%9F%A5%E8%AF%A2/EPC%E7%9B%AE%E5%BD%95%E6%9F%A5%E8%AF%A2/partPhotoUsingPOST
 */
export function partPhotoUsingPost(
  data: PartReq
): XDragonApiResponsePromise<PartPhotoUsingPostApiResponse> {
  return ajax({
    url: '/api/tis/web/epc/catalog/part/photo',
    method: 'post',
    data: data
  });
}
